export const debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
};
export const generateUniqueId = (): string =>
    crypto?.randomUUID?.() || `group-${Date.now()}-${Math.random()}`;
export function getFromStorage<T>(key: string, defaultValue: T): T {
    if (typeof window === 'undefined') return defaultValue;
    try {
        const stored = localStorage.getItem(key);
        if (stored === null) return defaultValue;
        if (typeof defaultValue === 'boolean') return (stored === 'true') as T;
        if (typeof defaultValue === 'number') return Number(stored) as T;
        return JSON.parse(stored) as T;
    } catch {
        return defaultValue;
    }
}
